import { TouchableOpacity } from "react-native";
import React, { useState, useRef } from "react";
import { Colors } from "colors";
import ImageView from "../../src/image";
import { Svg } from "assets/svg";
import VText from "components/VText";
import { wp, hp } from "utils/normalizeV2";
import SimilarProducts from "./aistylist/similarProducts";

const SimilarProductButtonCop = ({ productId }) => {
  const [isVisible, setIsVisible] = useState(false);
  const similarProductsRef = useRef();

  const showSimilarProducts = () => {
    similarProductsRef.current.show();
    setIsVisible(true);
  };

  return (
    <>
      <TouchableOpacity
        onPress={showSimilarProducts}
        style={{
          backgroundColor: Colors.white,
          position: "absolute",
          right: wp(35),
          bottom: hp(30),
          flexDirection: "row",
          alignItems: "center",
          gap: wp(10),
          paddingHorizontal: wp(10),
          paddingVertical: hp(10),
          borderRadius: wp(5),
          width: wp(145),
          height: hp(45),
          justifyContent: "center",
          alignItems: "center",
          borderColor: Colors.borderColor,
        }}
      >
        <ImageView
          source={Svg.multipleProducts}
          style={{ width: 24, height: 24 }}
        />
        <VText
          style={{
            fontFamily: "Helvetica",
            fontSize: wp(14),
            color: Colors.black,
            fontWeight: "600",
          }}
        >
          View Similar
        </VText>
      </TouchableOpacity>

        <SimilarProducts
          ref={similarProductsRef}
          product={{ id: productId }}
          isVisible={isVisible}
          setIsVisible={setIsVisible}
      />
    </>
  );
};

export default SimilarProductButtonCop;
